module.exports = __webpack_public_path__ + "static/media/Golisopod_gaussian2.775342d5.png";